{
  "sourceRefs": ["meischke-burgerweeshuis", "woodcut-1544"],
  "note": "The island tip north of the 1532 passage was sold to house carpenter Jacob Jansz on 16 December 1536. Meischke pp. 118 and 127 identifies a house and timber yard in the 1544 woodcut. Back-projecting that working property to 1538 is an inference; the sale alone does not establish completed buildings. The gabled house and lower front section follow the later image's hierarchy, not measured 1538 corners. Parcel limits, registration, dimensions, roof direction, heights, materials, doors, windows, timber stock and its arrangement are estimates. Later shipwright use and the newly built warehouse recorded in 1562 are excluded.",
  "houses": [
    {
      "id": "carpenter-house",
      "u": 0,
      "v": 0,
      "length": 13,
      "width": 7.2,
      "eaves": 4.3,
      "ridge": 8,
      "floors": 1,
      "bays": 3,
      "passage": 0,
      "doorSide": 0,
      "blindSides": [3],
      "gableWindowSides": [3]
    },
    {
      "id": "lower-front-section",
      "u": -8.5,
      "v": 0.8,
      "length": 4,
      "width": 4.6,
      "eaves": 2.7,
      "ridge": 4.4,
      "floors": 1,
      "bays": 1,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [1],
      "windowRows": [
        {
          "sill": 0.85,
          "top": 2.15,
          "width": 0.65
        }
      ]
    }
  ],
  "timber": [
    {
      "u": 8.673,
      "v": -8.272,
      "angleDeg": -37.4,
      "length": 8,
      "width": 1.5,
      "layers": 3,
      "boards": 3
    },
    {
      "u": -3.558,
      "v": -10.517,
      "angleDeg": -37.4,
      "length": 6,
      "width": 1.8,
      "layers": 3,
      "boards": 4
    }
  ]
}
